import { useState } from "react";
import { NormTextList } from "./NormTextList";
import type { LearningExercise } from "../types";

// Enge Cloze: genau eine Luecke (___) im prompt, Auswahl per Dropdown (kein Freitext).
// Bewertung ueber answers[0]; nach der Wahl erscheint Feedback + Gesetzestext.
export function ClozeCard({ exercise, onComplete }: { exercise: LearningExercise; onComplete: (correct: boolean) => void }) {
  const [picked, setPicked] = useState<number | null>(null);
  const [before, after] = exercise.prompt.split("___");
  const correct = picked !== null && exercise.answers.includes(picked);

  function choose(value: string) {
    if (picked !== null) return;
    const idx = Number(value);
    setPicked(idx);
    onComplete(exercise.answers.includes(idx));
  }

  return (
    <section className="cloze-card">
      <h3>{exercise.title}</h3>
      <p className="prompt">
        {before}
        <select
          aria-label="Luecke"
          className="cloze-select"
          disabled={picked !== null}
          onChange={(e) => choose(e.target.value)}
          value={picked ?? ""}
        >
          <option value="" disabled>
            …
          </option>
          {exercise.options.map((option, index) => (
            <option key={index} value={index}>
              {option}
            </option>
          ))}
        </select>
        {after}
      </p>
      {picked !== null ? (
        <div className={`feedback-panel ${correct ? "is-correct" : "is-wrong"}`}>
          <strong>{correct ? "Sitzt." : `Nicht ganz - richtig ist: ${exercise.options[exercise.answers[0]]}`}</strong>
          {exercise.explanation ? <p>{exercise.explanation}</p> : null}
          <NormTextList sources={exercise.sources} />
        </div>
      ) : null}
    </section>
  );
}
